var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-trainer-loader"},[(_vm.isLoading)?_c('section',{staticClass:"loading"},[_c('img',{attrs:{"src":require("@chalkysticks/sass/build/asset/image/loader/triangle-white.svg")}}),_c('p',[_vm._v(_vm._s(_vm.loadingText))])]):_c('section',{staticClass:"scene"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }